import Vue from "vue";
import router from "../../router";
const getDefaultState = () => {
  return {
    MainNavigation: [
      {
        icon: "mdi-sitemap",
        title: "Organisation",
        credentials: {
          isSuperAdmin: false,
          isAdmin: true,
        },
        items: [
          /*  {
            title: "Bailleurs",
            route: "/organisation",
            icon: "mdi-cube",
            credentials: {
              isSuperAdmin: true,
            },
          }, */
          {
            title: "Bailleurs",
            route: "/organisation/bailleurs",
            icon: "mdi-cube",
            credentials: {
              isSuperAdmin: true,
            },
          },
          /* {
            title: "Activités",
            route: "/activites",
            icon: "mdi-server",
            credentials: {
              isSuperAdmin: true,
            },
          }, */
          {
            title: "Thèmes",
            route: "/organisation/themes",
            icon: "mdi-content-copy",
            credentials: {
              isSuperAdmin: true,
            },
          },
          {
            title: "Type de Détails des étapes",
            route: "/organisation/typeDetailEtape",
            icon: "mdi-content-copy",
            credentials: {
              isSuperAdmin: true,
            },
          },
          {
            title: "Campagnes",
            route: "/organisation/campagnes",
            icon: "mdi-format-list-text",
            credentials: {
              isSuperAdmin: true,
            },
          },

          {
            title: "Rôles hors groupes",
            route: "/organisation/rolesHorsGroupe",
            icon: "mdi-account-box",
            credentials: {
              isSuperAdmin: true,
            },
          },
        ],
      },

      {
        icon: "mdi-apps",
        title: "Formations",
        credentials: {
          isSuperAdmin: false,
          isAdmin: true,
        },
        items: [
          {
            title: "Formations de masse",
            route: "/formationsDeMasse",
            icon: "mdi-server",
            credentials: {
              isSuperAdmin: true,
            },
          },
          {
            title: "Formations de groupe",
            route: "/groupes/formationsDeGroupe",
            icon: "mdi-server",
            credentials: {
              isSuperAdmin: true,
            },
          },
        ],
      },

      {
        icon: "mdi-google-maps",
        title: "Géographie",
        credentials: {
          isSuperAdmin: false,
        },
        items: [
          {
            title: "Régions",
            route: "/geographie/regions",
            icon: "mdi-earth",
            credentials: {
              isSuperAdmin: true,
            },
          },
          /* {
            title: "Provinces",
            route: "/geographie",
            icon: "mdi-map-marker-radius",
            credentials: {
              isSuperAdmin: true,
            },
          },
          {
            title: "Régions",
            route: "/geographie",
            icon: "mdi-map-marker-radius",
            credentials: {
              isSuperAdmin: true,
            },
          },
          {
            title: "Districts",
            route: "/geographie",
            icon: "mdi-map-marker-radius",
            credentials: {
              isSuperAdmin: true,
            },
          },
          {
            title: "Communes",
            route: "/geographie",
            icon: "mdi-map-marker-radius",
            credentials: {
              isSuperAdmin: true,
            },
          },
          {
            title: "Fokontany",
            route: "/fokontany",
            icon: "mdi-map-marker-radius",
            credentials: {
              isSuperAdmin: true,
            },
          },
          {
            title: "Villages",
            route: "/geographie",
            icon: "mdi-map-marker-radius",
            credentials: {
              isSuperAdmin: true,
            },
          }, */
        ],
      },

      {
        icon: "mdi-home-group",
        title: "Social",
        credentials: {
          isSuperAdmin: false,
          isAdmin: true,
        },
        items: [
          {
            title: "Groupes",
            route: "/groupes",
            icon: "mdi-home-group",
            credentials: {
              isSuperAdmin: true,
            },
          },
          {
            title: "Ménages",
            route: "/menages",
            icon: "mdi-home-roof",
            credentials: {
              isSuperAdmin: true,
            },
          },
         /*  {
            title: "Membres NAN",
            route: "/membresnan",
            icon: "mdi-home-roof",
            credentials: {
              isSuperAdmin: true,
            },
          }, */
        ],
      },

      {
        icon: "mdi-account-multiple",
        title: "Utilisateurs",
        credentials: {
          isSuperAdmin: true,
          isAdmin: true,
          isSuperviseur: false,
        },
        items: [
          /*     {
            title: "Comptes",
            route: "/users",
            icon: "mdi-account-box",
            credentials: {
              isSuperAdmin: true,
            },
          }, */
          {
            title: "Admins",
            route: "/users/identifiants#admins",
            icon: "mdi-account-circle",
            credentials: {
              isSuperAdmin: true,
            },
          },
          {
            title: "Identifiants",
            route: "/users/identifiants#actifs",
            icon: "mdi-account-circle",
            credentials: {
              isSuperAdmin: true,
            },
          },
          {
            title: "Inactifs",
            route: "/users/identifiants#inactifs",
            icon: "mdi-account-circle",
            credentials: {
              isSuperAdmin: true,
            },
          },
          {
            title: "Animateurs",
            route: "/users/identifiants#superviseurs",
            icon: "mdi-account-outline",
            credentials: {
              isSuperAdmin: true,
            },
          },
          {
            title: "Superviseurs régionaux",
            route: "/users/identifiants#regionaux",
            icon: "mdi-map-marker-radius-outline",
            credentials: {
              isSuperAdmin: true,
            },
          },
          {
            title: "Opérateurs de saisie",
            route: "/users/identifiants#operateurs",
            icon: "mdi-keyboard",
            credentials: {
              isSuperAdmin: true,
            },
          },
          {
            title: "Paysans Relais",
            route: "/users/identifiants#pr",
            icon: "mdi-account-supervisor-circle",
            credentials: {
              isSuperAdmin: true,
            },
          },
        ],
      },
      {
        icon: "mdi-codepen",
        title: "Réglages",
        credentials: {
          isSuperAdmin: true,
          isAdmin: true,
        },
        items: [
          {
            title: "Générales",
            route: "/reglages",
            icon: "mdi-monitor",
            credentials: {
              isSuperAdmin: true,
            },
          },
          {
            title: "Logs de connexion",
            route: "/online",
            icon: "mdi-login",
            credentials: {
              isSuperAdmin: true,
            },
          },
          /*  {
            title: "Langues",
            route: "/langage",
            icon: "mdi-earth",
            credentials: {},
          }, */
          /* {
            title: "Notifications",
            route: "/message",
            icon: "mdi-bell-ring",
            credentials: {
              isSuperAdmin: true,
            },
          },
          {
            title: "Traitements",
            route: "/traitement",
            icon: "mdi-needle",
            credentials: {},
          }, */
        ],
      },
    ],
    AdminNavigation: [
      {
        title: "Utilisateurs",
        route: "/Users/identifiants",
        icon: "mdi-account-group",
      },
      {
        title: "Organisation",
        route: "/organisation/bailleurs",
        icon: "mdi-sitemap",
      },
      {
        title: "Formations",
        route: "/formationsDeMasse",
        icon: "mdi-school",
      },
      {
        title: "Groupes",
        route: "/groupes",
        icon: "mdi-home-group",
      },
    ],
    SuperviseurNavigation: [
      {
        title: "Accueil",
        route: "/animateur",
        icon: "mdi-home",
      },
      /*   {
        title: "Formations",
        route: "/formationsDeMasse/superviseur/",
        icon: "mdi-school",
      }, */
      {
        title: "Profil",
        route: "/profil",
        icon: "mdi-account-box-outline",
      },
      /* {
        title: "Data",
        route: "/data",
        icon: "mdi-reload",
      }, */
    ],
    GroupeNavigation: [
      {
        title: "Dashboard",
        route: "/",
        icon: "mdi-view-dashboard",
      },
      {
        title: "Groupe",
        route: "/groupe",
        icon: "mdi-home-group",
      },
    ],
  };
};
// initial state
const state = getDefaultState();

const mutations = {
  resetnavigationState(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  resetnavigationState({ commit }) {
    commit("resetnavigationState");
  },
  goHome() {
    if (router.history.current.path !== "/") {
      router.push({ path: "/" });
    }
  },
  goBack() {
    router.back();
  },
  goNext() {
    router.go(1);
  },
};

const getters = {
  MainNavigation: (state) => {
    return state.MainNavigation;
  },
  AdminNavigation: (state) => {
    return state.AdminNavigation;
  },
  SuperviseurNavigation: (state) => {
    return state.SuperviseurNavigation;
  },
  GroupeNavigation: (state) => {
    return state.GroupeNavigation;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
